module.exports = __webpack_public_path__ + "img/icon_eyes_solid.eb945a5d.svg";